import React from 'react';
import { UpdateStatusDialog } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { getOfferStatusDialogConfig } from '../pages/offerList/offerStatusDialogConfig';

export interface OfferUpdateStatusDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  offerName: string;
  isActive: boolean;
  isSubmitting?: boolean;
}

/**
 * Shared offer status (activate/deactivate) confirmation dialog.
 * Use this on both the offer list and edit offer screen so the dialog is identical.
 */
export const OfferUpdateStatusDialog: React.FC<
  OfferUpdateStatusDialogProps
> = ({
  open,
  onClose,
  onConfirm,
  offerName,
  isActive,
  isSubmitting = false,
}) => (
  <UpdateStatusDialog
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    isSubmitting={isSubmitting}
    {...getOfferStatusDialogConfig(offerName, isActive)}
  />
);
